import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminRamUser } from '../../../actions/managerListsActions';
import { UnassignedMetroSource } from '../../../enums/ManagerListSource';
import { MultiSelectFilter } from './MultiSelectFilter';
import { peopleOptions, toPersonOptions } from './peopleOptions';

/**
 * RAM owner filter, over the admin RAM users.
 *
 * Once the list's own reserved Unassigned metro is the "no metro" option, it is
 * offered and sent like any metro, so `unassignedLabel` and the sentinel entry
 * give way to it.
 */
export const RamFilter = ({
  filter,
  handleFilterChange,
  label = 'RAM',
  unassignedLabel = 'Unassigned',
}) => {
  const dispatch = useDispatch();
  const ramList = useSelector((state) => state.users.ramUsers);
  const listsUnassignedMetro = useSelector(
    (state) => state.users.managerListSources?.unassignedMetro === UnassignedMetroSource.SalesMetro,
  );

  useEffect(() => {
    if (!ramList) {
      dispatch(getAdminRamUser());
    }
  }, [dispatch, ramList]);

  return (
    <MultiSelectFilter
      label={label}
      options={
        listsUnassignedMetro ? toPersonOptions(ramList) : peopleOptions(ramList, unassignedLabel)
      }
      value={filter?.ram}
      onChange={(value) => handleFilterChange('ram', value)}
    />
  );
};

export default RamFilter;
